import React from 'react';
import { MaintenanceActivity } from '../../../../../Helpers/maintenanceCostUtils';
import { uploadMaintenanceActivityAttachment } from '../../utils/maintenanceAttachmentUtils';
import { CostConfigurationModal, CostConfigurationData } from './shared';
import { CostUnit } from '../../../../Förvaltning/TemplatesEditor/types';

interface CostSettingsModalProps {
    componentKey: string;
    templateId: string;
    templateName: string;
    buildingKey: string;
    activity: MaintenanceActivity;
    calculatedCost: number;
    quantity: number | null;
    costExplanation: string;
    componentType: string;
    componentTypeName: string;
    templateCost: number;
    templateCostUnit: CostUnit;
    canEditTemplateCost?: boolean;
    onSave: (settings: CostConfigurationData) => void;
    onClose: () => void;
    onOpenEditTemplateCost: () => void;
}

/**
 * Modal for configuring cost settings for a maintenance activity.
 * Schablon, anpassad schablon (own unit price) or kostnad enligt offert, with comment, attachments and investment share.
 */
export const CostSettingsModal: React.FC<CostSettingsModalProps> = ({
    componentKey,
    templateId,
    templateName,
    buildingKey,
    activity,
    calculatedCost,
    quantity,
    costExplanation,
    templateCost,
    templateCostUnit,
    canEditTemplateCost = true,
    onSave,
    onClose,
    onOpenEditTemplateCost
}) => {
    const handleUpload = (file: File, userId: string) => {
        return uploadMaintenanceActivityAttachment(
            buildingKey,
            componentKey,
            templateId,
            file,
            userId
        );
    };

    return (
        <CostConfigurationModal
            title={`Kostnadsinställningar - ${templateName}`}
            costExplanation={costExplanation}
            calculatedCost={calculatedCost}
            templateUnitPrice={templateCost}
            costUnit={templateCostUnit}
            quantity={quantity}
            attachmentEntityType="maintenanceActivityAttachment"
            initialCostSource={activity.costSource || 'template'}
            initialCustomCost={activity.costSource === 'custom' ? activity.cost : undefined}
            initialCustomUnitPrice={activity.costSource === 'customRate' ? activity.customUnitPrice : undefined}
            initialComment={activity.costComment}
            initialAttachments={activity.costAttachments}
            initialInvestmentPercentage={activity.investmentPercentage}
            uploadAttachment={handleUpload}
            onSave={onSave}
            onClose={onClose}
            onOpenEditTemplateCost={onOpenEditTemplateCost}
            canEditTemplateCost={canEditTemplateCost}
        />
    );
};
